export const MESSAGES = {
  ERROR: {
    $401: 'Your session is expired, please login again.',
    $404: 'Resource not found',
    $500: 'Internal Server Error',
    $504: 'Slow Internet Connection',
    $0: 'Something went wrong, Please try again.',
    UNKNOWN: 'Something went wrong at our end'
  },
  NAVIGATION: {
    NOT_FOUND: 'Navigation error occured'
  },
  OFFLINE: 'You are offline, please connect to internet and retry'
};

export const ERROR_MESSAGES = {

};


export const APPROVE = {
  confirm: (type, count = 1) => `Do you want to approve ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been Approved successfully`
};
export const REJECT = {
  confirm: (type, count = 1) => `Do you want to reject ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been Rejected successfully`
};

export const DELETED = {
  confirm: (type, count = 1) => `Are you sure you want to delete  ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been deleted successfully`
};

export const UNBLOCKED = {
  confirm: (type, count = 1) => `Are you sure you want to unblock ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been unblocked successfully`
};

//  this post as read?
export const MARK_AS_READ = {
  confirm: (type, count = 1) => `Are you sure you want to mark ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()} as read?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been marked as read successfully`
};

export const MARK_AS_UNREAD = {
  confirm: (type, count = 1) => `Are you sure you want to mark ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()} as Unread?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been marked as Unread successfully`
};

export const BLOCKED = {
  confirm: (type, count = 1) => `Are you sure you want to block ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been blocked successfully`
};
export const INACTIVE = {
  confirm: (type, count = 1) => `Are you sure you want to block ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been blocked successfully`
};

export const ACTIVE = {
  confirm: (type, count = 1) => `Are you sure you want to unblock ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been unblocked successfully`
};


export const PUBLISHED = {
  confirm: (type, count = 1) => `Do you want to publish ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been published successfully`
};

export const INVITE = {
  confirm: (type, count = 1) => `Do you want to invite ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been invited successfully`
};

export const ADDED = (type) => `${type} added successfully`;

export const UPDATED = (type) => `${type} updated successfully`;

export const invalidImageError = (format = 'jpeg/png') => `Only ${format} images are allowed`;

export const invalidVideoError = (format = 'mp4/webm/ogg') => `Only ${format} videos are allowed`;
export const invalidAudioError = (format = 'mp3/wav/mpeg') => `Only ${format} audios are allowed`;

export const invalidFileSize = (size = 4) => `File size can not be more than ${size} MB`;
export const SYNC_DATA_SUCCESS = (name) => `${name} synced successfully`;
export const CYCLE_YEAR_REQUIRED = 'Please select a year of cycle';
export const FORUM_IMAGE = 'Please upload a forum image';
export const PODCAST_IMAGE = 'Please upload a podcast image';
export const AUDIO = 'Please upload a episode audio';
export const FILE_REQUIRED = 'Please upload a excel file';
export const FILL_ALL_DETAILS = 'Please Fill All Details';
export const SELECT_FORUM = 'Please Select a Forum';
export const NO_DATA_FOUND = {
  FORUM: 'No forum found'
};

export const CLEARED_STATUS_MESSAGE = (type: string) => `This ${type} is already cleared`;

export const REP_TYPE_NOT_SELECTED = 'Please Select Representative Type';
export const REP_SELECT_LIMIT = 'Please select less than or equal to 25';
export const LEG_SYNC_REQUIREMENT = 'Please select congress and type';
export const LEG_STATE_REQUIREMWNT = 'Please select atleast 1 state';
export const INVITE_ERROR = 'Please Select at least one representative have its email Id';
export const INTEREST_APPROVE_SUCCESS = 'Interest has been successfully approved';

export const RESENDNOTIFICATION = 'Notification resent successfully';
export const ADDBALLOT = 'Ballots added successfully';
export const ADDMEASURES = 'Measures added successfully';
export const CSV_FILE_REQUIRED = 'Please upload a csv file only';


export const USER_PLATFORM_WEB = 'If Platform is Web you can only select User Recipients';

export const SELECT_PLATFORM = 'Please Select atleast one platform';
